import { Box, Flex, Spinner } from '@radix-ui/themes';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense, useState } from 'react';
import { z } from 'zod';
import { SimpleErrorBoundary } from '~/components/errors/SimpleErrorBoundary';
import { Carousel } from '~/features/landing/components/Carousel';
import { Hero } from '~/features/landing/components/Hero';
import { LandingPageHeader } from '~/features/landing/components/LandingPageHeader';
import { PromptLibrary } from '~/features/landing/components/PromptLibrary';
import { messages } from '~/features/landing/constants';

const searchSchema = z.object({
  q: z.string().optional(),
  category: z.string().optional(),
});

export const Route = createFileRoute('/')({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ context }) => {
    return {
      organisation: context.organisation,
      organisations: context.organisations,
      session: context.session,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const [prompt, setPrompt] = useState<string>();

  function updatePrompt(prompt: string) {
    setPrompt(prompt);
  }

  return (
    <Box pb="5" style={{ backgroundColor: 'var(--cyan-1)' }}>
      <LandingPageHeader />
      <Hero prompt={prompt} onPromptChange={updatePrompt} style={{ marginTop: '50px' }} />
      <Flex direction={'column'} gap="4" style={{ marginTop: '50px' }}>
        <Carousel messages={messages} />
        <Carousel style={{ right: 250 }} messages={messages} />
      </Flex>

      <Flex minHeight="30rem" justify="center" align="center">
        <SimpleErrorBoundary text="There was an error loading the prompt library.">
          <Suspense
            fallback={
              <Flex justify="center" align="center" height="30rem">
                <Spinner />
              </Flex>
            }
          >
            <PromptLibrary
              style={{ marginTop: '100px', maxWidth: '1417px', marginInline: 'auto' }}
              onPromptChange={updatePrompt}
            />
          </Suspense>
        </SimpleErrorBoundary>
      </Flex>
    </Box>
  );
}
